"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Configuration = void 0;
class Configuration {
    static apiVersion() {
        return "2017-10-17";
    }
    static region() {
        return "us-west-2";
    }
}
exports.Configuration = Configuration;
//# sourceMappingURL=configuration.js.map